
export default function Gallery() {
  const galleryImages = [
    {
      url: 'https://public.readdy.ai/ai/img_res/85b73e8e59396cfeab313bf3290eb8f3.jpg',
      title: 'Crocância Perfeita'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=red%20branded%20bucket%20overflowing%20with%20golden%20fried%20chicken%20pieces%20on%20solid%20red%20background%2C%20professional%20food%20photography%2C%20abundant%20portion%2C%20restaurant%20quality%20presentation&width=600&height=600&seq=gallery-002&orientation=squarish',
      title: 'Buckets Exclusivos'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=family%20enjoying%20fried%20chicken%20meal%20together%20at%20table%20with%20red%20buckets%20on%20solid%20red%20background%2C%20happy%20dining%20experience%2C%20sharing%20food%20moment%2C%20warm%20atmosphere&width=600&height=600&seq=gallery-003&orientation=squarish',
      title: 'Momentos em Família'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=delivery%20person%20holding%20red%20bucket%20of%20fried%20chicken%20with%20motorcycle%20in%20background%20on%20solid%20red%20background%2C%20fast%20delivery%20service%2C%20professional%20courier%2C%20food%20delivery%20concept&width=600&height=600&seq=gallery-004&orientation=squarish',
      title: 'Entrega Rápida'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=chef%20hands%20preparing%20and%20seasoning%20fresh%20chicken%20pieces%20in%20professional%20kitchen%20on%20solid%20red%20background%2C%20cooking%20process%2C%20culinary%20expertise%2C%20food%20preparation%20detail&width=600&height=600&seq=gallery-005&orientation=squarish',
      title: 'Preparo Artesanal'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=variety%20of%20fried%20chicken%20pieces%20with%20different%20sides%20and%20sauces%20arranged%20beautifully%20on%20solid%20red%20background%2C%20complete%20meal%20spread%2C%20professional%20food%20styling%2C%20appetizing%20display&width=600&height=600&seq=gallery-006&orientation=squarish',
      title: 'Variedade de Sabores'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=golden%20crispy%20chicken%20wings%20with%20steam%20rising%20on%20solid%20red%20background%2C%20hot%20fresh%20food%2C%20professional%20food%20photography%2C%20dramatic%20lighting%2C%20appetizing%20presentation&width=600&height=600&seq=gallery-007&orientation=squarish',
      title: 'Sempre Quentinho'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=party%20table%20with%20multiple%20red%20buckets%20of%20fried%20chicken%20and%20happy%20people%20celebrating%20on%20solid%20red%20background%2C%20festive%20atmosphere%2C%20social%20gathering%2C%20food%20party%20concept&width=600&height=600&seq=gallery-008&orientation=squarish',
      title: 'Perfeito para Festas'
    }
  ];

  return (
    <section id="gallery" className="py-16 md:py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-yellow-400 mb-4">
            GALERIA
          </h2>
          <div className="w-24 md:w-32 h-2 bg-yellow-400 mx-auto rounded-full"></div>
          <p className="text-white text-base md:text-xl mt-4 md:mt-6">Confira nossos deliciosos produtos!</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl md:rounded-2xl aspect-square cursor-pointer transform hover:scale-105 transition-all duration-300"
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <p className="text-white font-bold text-sm md:text-lg p-3 md:p-4 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  {image.title}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-16 text-center">
          <a
            href="https://www.instagram.com/buckets.chicken"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 md:gap-3 bg-gradient-to-r from-pink-500 to-rose-500 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-bold text-base md:text-lg hover:from-pink-600 hover:to-rose-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-instagram-fill text-xl md:text-2xl"></i>
            Siga no Instagram
            <i className="ri-arrow-right-line text-lg md:text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
